export const CONTENT_TYPES = {
  BOOTH:          'booth',
  BOOTH_MEDIA:    'booth_media',
  MEDIA:          'media',
  PORTAL:         'portal',
  CUSTOM_BOOTH_ITEM: 'custom_booth_item',
  CUSTOM:         'custom',
  ITEM:           'item',
  CHARITY:        'charity',
  ADVERTISER:     'advertiser',
  CAMPAIGN:       'campaign',
  AD:             'ad',
  HOSTING:        'hosting',
  EVENT:          'event',
  DISCOUNT:       'discount',
  TELEPORT:       'teleport',
  TELEPORT_BUTTON:'teleport_button',
  RECOGNITION:    'recognition',
  REWARD:         'reward',
  AI_MODERATION:  'ai_moderation',
  PAYMENT:        'payment',
  SUBSCRIPTION:   'subscription',
  LIGHTING:       'lighting',
  SELFIE:         'selfie',
  FREE_TRIAL_SETTING: 'free_trial_setting',
  FREE_TRIAL_ITEM:    'free_trial_item',
  PACKAGE:            'package',
  PACKAGE_ITEM:       'package_item',
  GAME_SCHEDULE:      'game_schedule',
};